module.exports = __webpack_public_path__ + "img/studio-background@small.63c5f137.png";